import React from 'react';
import Component from '../../BaseAsset';

import './style.scss';

export default class Title002 extends Component {
  static defaultProps = {
    ...Component.defaultProps,
    data: {
      ...Component.defaultProps.data,
      transitionFactor: 0.2,
      heading: 'Your Title',
      headingFont: 'Montserrat',
      headingColor: '#ffffff',
      useSubHeading: true,
      subHeading: 'Tagline',
      subHeadingFont: 'Montserrat',
      subHeadingColor: '#ff5e53',
      borderColor: '#ffffff',
    },
    properties: [
      ...Component.defaultProps.properties,
      'heading',
      'headingFont',
      'headingColor',
      'useSubHeading',
      'subHeading',
      'subHeadingFont',
      'subHeadingColor',
      'borderColor',
    ],
  };

  assetName = 'Title002';

  setup() {
    const { library, data } = this.props;
    const { useSubHeading, time, duration, transitionFactor } = data;
    const transitionDuration = transitionFactor * duration;
    const endTime = time + duration - 1;
    const tl = super.setup();

    let headingLetters;
    let subHeadingLetters;
    let headingLetterDelay;
    let subHeadingLetterDelay;

    let width = this.$headingText.offsetWidth;
    if ((library || useSubHeading) && this.$subHeadingText) {
      width = Math.max(this.$headingText.offsetWidth, this.$subHeadingText.offsetWidth);
    }

    tl.fromTo(this.$borderTop, { width: 0 }, { delay: transitionDuration * 0.2, duration: transitionDuration, width }, time);
    tl.fromTo(this.$borderMiddle, { width: 0 }, { delay: transitionDuration * 0.3, duration: transitionDuration, width }, time);
    
    if (this.$headingText) {
      headingLetters = this.$headingText.querySelectorAll('span');
      headingLetterDelay = transitionDuration / headingLetters.length;
      headingLetters.forEach(($el, index) => {
        tl.fromTo($el, { scale: 0 }, { delay: index * headingLetterDelay, duration: transitionDuration * 0.5, scale: 1 }, time);
      });
    }
    
    if (library || useSubHeading) {
      if (this.$subHeadingText) {
        subHeadingLetters = this.$subHeadingText.querySelectorAll('span');
        subHeadingLetterDelay = transitionDuration / subHeadingLetters.length;
        subHeadingLetters.forEach(($el, index) => {
          tl.fromTo($el, { scale: 0 }, { delay: index * subHeadingLetterDelay, duration: transitionDuration, scale: 1 }, time);
        });
        tl.fromTo(this.$borderBottom, { width: 0 }, { delay: transitionDuration * 0.4, duration: transitionDuration, width }, time);
      }
    }

    if (!library) {
      if (this.$assetWrapper) {
        tl.fromTo(this.$assetWrapper, { opacity: 1 }, { duration: 1, opacity: 0 }, endTime);
      }
    }

    return tl;
  }

  renderAsset() {
    const { assetName } = this;
    const { data } = this.props;
    const {
      heading,
      headingFont,
      headingColor,
      useSubHeading,
      subHeading,
      subHeadingFont,
      subHeadingColor,
      borderColor,
    } = data;

    return (
      <div className={`${assetName}__wrapper`} ref={ref => this.$assetWrapper = ref}>
        <div
          ref={ref => this.$borderTop = ref}
          className={`${assetName}__border--top`}
          style={{ backgroundColor: borderColor }}
        />
        <div
          ref={ref => this.$heading = ref}
          className={`${assetName}__heading`}
        >
          <div
            ref={ref => this.$headingText = ref}
            className={`${assetName}__heading--text`}
            style={{
              color: headingColor, 
              fontFamily: headingFont,
            }}
          >
            {heading.split('').map((letter, index) => <span key={index} className="letter">{letter}</span>)}
          </div>
        </div>
        <div
          ref={ref => this.$borderMiddle = ref}
          className={`${assetName}__border--middle`}
          style={{ backgroundColor: borderColor }}
        />
        {useSubHeading && (
          <React.Fragment>
            <div
              ref={ref => this.$subHeading = ref}
              className={`${assetName}__subHeading`}
            >
              <div
                ref={ref => this.$subHeadingText = ref}
                className={`${assetName}__subHeading--text`}
                style={{
                  color: subHeadingColor,
                  fontFamily: subHeadingFont,
                }}
              >
                {subHeading.split('').map((letter, index) => <span key={index} className="letter">{letter}</span>)}
              </div>
            </div>
            <div
              ref={ref => this.$borderBottom = ref}
              className={`${assetName}__border--bottom`}
              style={{ backgroundColor: borderColor }}
            />
          </React.Fragment>
        )}
      </div>
    );
  }

  renderShadowAsset() {
    const { assetName } = this;
    const { data } = this.props;
    const {
      heading,
      headingFont,
      useSubHeading,
      subHeading,
      subHeadingFont,
    } = data;


    return (
      <div className={`${assetName}__shadow`}>
        <div className={`${assetName}__border--top`} />
        <div className={`${assetName}__heading`}
            style={{ fontFamily: headingFont }}
          >
          <div className={`${assetName}__heading--text`}>
            {heading}
          </div>
        </div>
        <div className={`${assetName}__border--middle`} />
        {useSubHeading && (
          <React.Fragment>
            <div className={`${assetName}__subHeading`}
              style={{ fontFamily: subHeadingFont }}
            >
              <div className={`${assetName}__subHeading--text`}>
                {subHeading}
              </div>
            </div>
            <div className={`${assetName}__border--bottom`} />
          </React.Fragment>
        )}
      </div>
    );
  }
}